import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { GlobalServicesService } from './global-services.service';

@Injectable({
    providedIn: 'root'
})

export class OtpService {
    host_api_url = environment.HOST.HOST_API_URL;
    fast_api_url = environment.HOST.FAST_API_URL;

    constructor(private http: HttpClient,private globalService: GlobalServicesService) { }

    //fast apis
    // verifyOtpFastApi(payload:any):Observable<any>{
    //     return this.http.post(this.fast_api_url + '/auth/verify-otp', payload, this.options_fast_api());
    // }
    // sendOtpFastApi(payload:any):Observable<any>{
    //     return this.http.post(this.fast_api_url + '/auth/resend-otp', payload, this.options_fast_api());
    // }
    verifyOtpFastApi(payload: any): Observable<HttpResponse<any>> {
        return this.http.post<HttpResponse<any>>(this.fast_api_url + '/auth/verify-otp', payload, {
          observe: 'response'
        }).pipe(
          catchError((error: HttpErrorResponse) => throwError(() => error))
        );
    }
    
    sendOtpFastApi(payload: any): Observable<HttpResponse<any>> {
        return this.http.post<HttpResponse<any>>(this.fast_api_url + '/auth/resend-otp', payload, {
          observe: 'response',
        }).pipe(
          catchError(this.globalService.handleError.bind(this.globalService))
        );
    }
    sendForgotPasswordFastApi(payload: any): Observable<HttpResponse<any>> {
        return this.http.post<HttpResponse<any>>(this.fast_api_url + '/auth/forgot-password', payload, {
          observe: 'response',
        }).pipe(
          catchError(this.globalService.handleError.bind(this.globalService))
        );
    }

    sendCandidateOtpFastApi(payload:any, eventId:string, origin?: string, sourceId?: string): Observable<HttpResponse<any>> {
        const requestPayload = origin ? { ...payload, origin } : payload;
        
        return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/candidates/verify-email`, requestPayload, {
          observe: 'response',
          params: sourceId ? {
            source_id: sourceId
          } : undefined
        }).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 409 || error.error?.detail === "Candidate is already registered for this event.") {
              return throwError(() => error);
            }
            return this.globalService.handleError(error);
          })
        );
    }

    sendCandidateInterviewOtpFastApi(payload:any, stageId:string, interviewId:string): Observable<HttpResponse<any>> {
      return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/stages/${stageId}/interviews/${interviewId}/verify-email`, payload, {
        observe: 'response',
      }).pipe(
         catchError((error: HttpErrorResponse) => throwError(() => error))
      );
    }

    verifyCandidateOtpFastApi(payload: any, eventId:string): Observable<HttpResponse<any>> {
        return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/candidates/verify-otp`, payload, {
          observe: 'response',
        }).pipe(
          catchError(this.globalService.handleError.bind(this.globalService))
        );
    }

    sendCandidateTestOtpFastApi(payload:any, stageId:string, rawErrors: boolean = false): Observable<HttpResponse<any>> {
      const request = this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/stages/${stageId}/candidates/tests/verify-email`, payload, {
        observe: 'response',
      });
      return rawErrors
        ? request.pipe(catchError((error: HttpErrorResponse) => throwError(() => error)))
        : request.pipe(catchError(this.globalService.handleError.bind(this.globalService)));
    }

    verifyCandidateTestOtpFastApi(payload: any, stageId:string): Observable<HttpResponse<any>> {
      return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/stages/${stageId}/candidates/tests/verify-otp`, payload, {
        observe: 'response',
      }).pipe(
        catchError(this.globalService.handleError.bind(this.globalService))
      );
    }

    verifyCandidateInterviewOtpFastApi(payload: any, stageId:string, interviewId:string): Observable<HttpResponse<any>> {
      return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/stages/${stageId}/interviews/${interviewId}/verify-otp`, payload, {
        observe: 'response',
      }).pipe(
        catchError(this.globalService.handleError.bind(this.globalService))
      );
    }

    resolveWalkInStageFastApi(shortCode: string): Observable<HttpResponse<any>> {
      return this.http.get<HttpResponse<any>>(this.fast_api_url + `/events/walk-in/${shortCode}`, {
        observe: 'response',
      }).pipe(
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
    }

    verifyWalkInKeyFastApi(payload: any, shortCode: string): Observable<HttpResponse<any>> {
      return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/walk-in/${shortCode}/verify-key`, payload, {
        observe: 'response',
      }).pipe(
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
    }

}